export default {
  asset: "Activos",
  article: "Artículos",
  feature: "Características Adicionales",
};
